import React from 'react';
import PrimaryScoreCardContent from './resultCardContent/primaryScoreCardContent';
import SecondaryScoreCardContent from './resultCardContent/secondaryScoreCardContent';

import './resultCardItem.scss';

const ResultCardItem = ({result, assessment, priority}) => {
    const headings = [
        'Your Best Matched Health Personality',
        'Your Secondary Health Personality',
        'Other Health Personalities'
    ];

    const component =
        priority === 0 ? (
            <PrimaryScoreCardContent
                result={result}
                heading={headings[priority]}
                assessment={assessment}
            />
        ) : (
            <SecondaryScoreCardContent
                result={result}
                heading={headings[priority]}
                assessment={assessment}
            />
        );

    return <>{component}</>;
};

export default ResultCardItem;
